import { PluginContainerData, Link } from "./common";
import { LinkPreviewData_Styles_Position } from "./plugin_link_preview.enums";
function linkPreviewData_Styles_PositionFromJSON(object) {
  switch (object) {
    case 0:
    case "START":
      return LinkPreviewData_Styles_Position.START;
    case 1:
    case "END":
      return LinkPreviewData_Styles_Position.END;
    case 2:
    case "TOP":
      return LinkPreviewData_Styles_Position.TOP;
    case 3:
    case "HIDDEN":
      return LinkPreviewData_Styles_Position.HIDDEN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LinkPreviewData_Styles_Position.UNRECOGNIZED;
  }
}
function linkPreviewData_Styles_PositionToJSON(object) {
  switch (object) {
    case LinkPreviewData_Styles_Position.START:
      return "START";
    case LinkPreviewData_Styles_Position.END:
      return "END";
    case LinkPreviewData_Styles_Position.TOP:
      return "TOP";
    case LinkPreviewData_Styles_Position.HIDDEN:
      return "HIDDEN";
    default:
      return "UNKNOWN";
  }
}
const baseLinkPreviewData = {};
const LinkPreviewData = {
  fromJSON(object) {
    const message = { ...baseLinkPreviewData };
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.link = object.link !== void 0 && object.link !== null ? Link.fromJSON(object.link) : void 0;
    message.title = object.title !== void 0 && object.title !== null ? String(object.title) : void 0;
    message.thumbnailUrl = object.thumbnailUrl !== void 0 && object.thumbnailUrl !== null ? String(object.thumbnailUrl) : void 0;
    message.description = object.description !== void 0 && object.description !== null ? String(object.description) : void 0;
    message.html = object.html !== void 0 && object.html !== null ? String(object.html) : void 0;
    message.styles = object.styles !== void 0 && object.styles !== null ? LinkPreviewData_Styles.fromJSON(object.styles) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.link !== void 0 && (obj.link = message.link ? Link.toJSON(message.link) : void 0);
    message.title !== void 0 && (obj.title = message.title);
    message.thumbnailUrl !== void 0 && (obj.thumbnailUrl = message.thumbnailUrl);
    message.description !== void 0 && (obj.description = message.description);
    message.html !== void 0 && (obj.html = message.html);
    message.styles !== void 0 && (obj.styles = message.styles ? LinkPreviewData_Styles.toJSON(message.styles) : void 0);
    return obj;
  }
};
const baseLinkPreviewData_Styles = {
  thumbnailPosition: LinkPreviewData_Styles_Position.START
};
const LinkPreviewData_Styles = {
  fromJSON(object) {
    const message = { ...baseLinkPreviewData_Styles };
    message.backgroundColor = object.backgroundColor !== void 0 && object.backgroundColor !== null ? String(object.backgroundColor) : void 0;
    message.titleColor = object.titleColor !== void 0 && object.titleColor !== null ? String(object.titleColor) : void 0;
    message.subtitleColor = object.subtitleColor !== void 0 && object.subtitleColor !== null ? String(object.subtitleColor) : void 0;
    message.linkColor = object.linkColor !== void 0 && object.linkColor !== null ? String(object.linkColor) : void 0;
    message.borderWidth = object.borderWidth !== void 0 && object.borderWidth !== null ? Number(object.borderWidth) : void 0;
    message.borderRadius = object.borderRadius !== void 0 && object.borderRadius !== null ? Number(object.borderRadius) : void 0;
    message.borderColor = object.borderColor !== void 0 && object.borderColor !== null ? String(object.borderColor) : void 0;
    message.thumbnailPosition = object.thumbnailPosition !== void 0 && object.thumbnailPosition !== null ? linkPreviewData_Styles_PositionFromJSON(object.thumbnailPosition) : LinkPreviewData_Styles_Position.START;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.backgroundColor !== void 0 && (obj.backgroundColor = message.backgroundColor);
    message.titleColor !== void 0 && (obj.titleColor = message.titleColor);
    message.subtitleColor !== void 0 && (obj.subtitleColor = message.subtitleColor);
    message.linkColor !== void 0 && (obj.linkColor = message.linkColor);
    message.borderWidth !== void 0 && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== void 0 && (obj.borderRadius = message.borderRadius);
    message.borderColor !== void 0 && (obj.borderColor = message.borderColor);
    message.thumbnailPosition !== void 0 && (obj.thumbnailPosition = linkPreviewData_Styles_PositionToJSON(message.thumbnailPosition));
    return obj;
  }
};
export {
  LinkPreviewData,
  LinkPreviewData_Styles,
  linkPreviewData_Styles_PositionFromJSON,
  linkPreviewData_Styles_PositionToJSON
};
//# sourceMappingURL=plugin_link_preview.js.map
